import { ContestStatus } from '@betterpool/api-types/contests-service';

import { useContestContext } from '../../../../common/context/ContestContext/ContestContext';
import { EntryNameEditModalContextProvider } from '../../../../common/context/EntryNameEditModalContext/EntryNameEditModalContext';
import { SlatesContextProvider } from '../../../../common/context/SlatesContext/SlatesContext';

import TeamSurvivorEntriesPageNonScheduled from './_entriesNonScheduled';
import TeamSurvivorEntriesPageScheduled from './_entriesScheduled';
import GamecenterModalsContextProvider from '../../../../common/context/GamecenterModalsContext/GamecenterModalsContextProvider';

function TeamSurvivorEntriesOverallPage() {
  const { contest } = useContestContext();

  return (
    <SlatesContextProvider ignoreQuery>
      <GamecenterModalsContextProvider>
        <EntryNameEditModalContextProvider>
          {contest.status === ContestStatus.SCHEDULED ? (
            <TeamSurvivorEntriesPageScheduled />
          ) : (
            <TeamSurvivorEntriesPageNonScheduled />
          )}
        </EntryNameEditModalContextProvider>
      </GamecenterModalsContextProvider>
    </SlatesContextProvider>
  );
}

export default TeamSurvivorEntriesOverallPage;
